<template lang="pug">
label.checkbox
  input.checkbox__input(
    :id='id'
    :value='modelValue'
    :checked='modelValue'
    type='checkbox'
    @input="onChange"
  )
  .checkbox__box
  slot
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export default defineNuxtComponent({
    name: 'CheckboxInput',

    props: {
      id: {
        type: String as PropType<string>,
        required: true,
      },

      modelValue: {
        type: Boolean as PropType<boolean>,
        required: true,
      },
    },

    methods: {
      onChange() {
        this.$emit('update:modelValue', !this.modelValue);
      },
    },
  });
</script>

<style lang="scss" scoped>
  .checkbox {
    display: inline-block;
    @include smallText;
    line-height: 25px;
    padding-left: 34px;
    position: relative;
    cursor: pointer;
    user-select: none;

    @include hover {
      .checkbox__box {
        border-color: var(--main-color);
      }
    }

    &__input {
      appearance: none;
      position: absolute;
      // polyfill
      width: 1px;
      height: 1px;
      overflow: hidden;
      clip: rect(0 0 0 0);
      outline: none;

      &:checked {
        & + .checkbox__box {
          border-color: var(--main-color);
          background-color: var(--main-color);

          @include hover {
            border-color: var(--hover-color);
            background-color: var(--hover-color);
          }

          &:before {
            @include checkMask;
            background: #fff;
          }
        }
      }
    }

    &__box {
      position: absolute;
      left: 0;
      top: 0;
      width: 16px;
      height: 16px;
      border: 1px solid #969698;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 4px;

      &:before {
        content: '';
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: transparent;
      }
    }
  }
</style>
